export default __webpack_public_path__ + "static/media/face_search_bg.9d854654.jpg";